export default {"src":"/_next/static/media/microsoftoffice.974515ca.svg","height":326,"width":256,"blurWidth":0,"blurHeight":0};